import NumberFormat from "react-number-format"

export const Summary = ({ form, handleAdd }) => {

    const { separacion_miles, separacion_decimales, simbolo } = form

    return (
        <div className='d-flex justify-content-center align-items-center'>
            <div style={{ border: '1px solid lightgray', padding: '10px', width: '100%' }}>
                <h5 style={{ fontSize: '14px', color: 'green' }}>Ingresos:</h5>
                <div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total ítem:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.precio_subtotal || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total proyectado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_proyectado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Saldo por proyectar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.saldo_por_proyectar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>

                    <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Facturado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_facturado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por Facturar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_por_facturar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>

                    <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Cobrado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_cobrado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por cobrar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_por_cobrar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>

                </div>
                <button
                    className="btn btn-link btn-sm p-mini-link p-fs-14"
                    onClick={() => handleAdd('ingreso')}
                >
                    + Agregar flujo
                </button>
            </div>
            <div style={{ border: '1px solid lightgray', borderLeft: '0px', padding: '10px', width: '100%' }}>
                <h5 style={{ fontSize: '14px', color: 'red' }}>Egresos:</h5>
                <div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total ítem:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.costo_subtotal || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Total proyectado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_proyectado_egresos || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Saldo por proyectar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.saldo_por_proyectar_egresos || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>

                    <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Gastado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_gastado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por gastar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_por_gastar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>

                    <div className='mt-1'>
                        <div>---</div>
                        <label style={{ fontWeight: 'bold' }}>Pagado:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_pagado || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>
                    <div>
                        <label style={{ fontWeight: 'bold' }}>Por pagar:</label>
                        <NumberFormat
                            style={{ fontSize: '13px' }}
                            displayType={'text'}
                            name="total_item"
                            className="text-end p-w-100 ms-1"
                            value={parseFloat(form?.total_por_pagar || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(con IGV)</span>
                    </div>

                </div>
                <button
                    className="btn btn-link btn-sm p-mini-link p-fs-14"
                    onClick={() => handleAdd('egreso')}
                >
                    + Agregar flujo
                </button>
            </div>
        </div>
    )
}